import { render, staticRenderFns } from "./SideMenuBar.vue?vue&type=template&id=ad5929a4"
import script from "./SideMenuBar.vue?vue&type=script&lang=js"
export * from "./SideMenuBar.vue?vue&type=script&lang=js"
import style0 from "./SideMenuBar.vue?vue&type=style&index=0&id=ad5929a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports